import { useContext } from "react";
import { Context } from "../../Provider";
import FtmStages from "../../../../components/ftmStages/FtmStages";
import EditAndChatButtons from "./EditAndChatButtons";

const FtmDetails = () => {
    const { state } = useContext(Context);
    const { ftm } = state;

    // Guard: if no data, show nothing (or a loader)
    if (!ftm) return null;

    const {
        ftm_profile_image_path = "/assets/img/lock_user.png",
        ftm_forename = "",
        ftm_surname = "",
        ftm_vehicle_number = "",
        ftm_stage_id
    } = ftm;

    return (
        <div className="card card-body mt-4">
            <div className="row gx-4">
                <div className="col-auto">
                    <div className="avatar avatar-xl position-relative">
                        <img src={ftm_profile_image_path} alt="profile_image" className="border-radius-lg" style={{ width: 74, height: 74 }} />
                    </div>
                </div>
                <div className="col-auto my-auto">
                    <div className="h-100">
                        <h5 className="mb-0">{ftm_forename} {ftm_surname}</h5>
                        <p className="mb-0 font-weight-normal text-sm">{ftm_vehicle_number}</p>
                    </div>
                    <div className="mt-1">
                        <FtmStages currentStage={ftm_stage_id} />
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 my-sm-auto ms-sm-auto me-sm-0 mx-auto mt-3">
                    <EditAndChatButtons/>
                </div>
            </div>
        </div>
    );
};

export default FtmDetails;